import { Box } from "./Box";

export const MultipleChoice = ({ label, array, onChange, options, required, error }) => {
  const changeArray = value => {
    let newArray = [...array];
    if (array.indexOf(value) === -1) {
      newArray.push(value);
      onChange(newArray);
    } else {
      const returnArray = newArray.filter(item => item !== value);
      onChange(returnArray);
    }
  };

  return (
    <section className="multiple_choice-main">
      <label className="multiple_choice-label">
        {label}
        <span>{required ? "Required" : ""}</span>
      </label>
      {options.map(option => (
        <Box
          text={option}
          checked={array.indexOf(option) !== -1}
          onChange={changeArray}
          key={option}
        />
      ))}
      <p className="multiple_choice-error">{error}</p>
    </section>
  );
};
